import React from 'react';
import useFilter from '@hooks/querys/useFilters';
import useSuggestion from '@hooks/querys/useSuggestion';
import {ParsedDataGFR} from '@services/new/common/getFilters';

export const useSearchOptions = () => {
  const filterQuery = useFilter('ft=c');
  const suggestionsQuery = useSuggestion('c');

  const suggestions = React.useMemo(() => {
    return (
      suggestionsQuery.data
        ?.filter(
          (s, index, self) =>
            self.findIndex((item) => item.label === s.label) === index
        )
        .map((item) => ({
          value: item.label,
          label: item.label,
          iconType: item.type,
        })) ?? []
    );
  }, [suggestionsQuery.data]);

  const filters: ParsedDataGFR = React.useMemo(() => {
    if (!filterQuery.data) {
      return {
        bedrooms: [],
        bathrooms: [],
        amenities: [],
        completionStatus: [],
        price: {min: 0, max: 0},
        types: [],
        unitView: [],
        resaleTypes: [],
        area: {min: 0, max: 0},
      };
    }
    return filterQuery.data;
  }, [filterQuery.data]);

  return {
    suggestions,
    filters,
    loading: suggestionsQuery.isLoading || filterQuery.isLoading,
  };
};
